const checkForMenuOverLength = () => {
    if (document.querySelector('.ume-menu-wrapper')) {
        const wrapper = document.querySelector('.ume-menu-wrapper');
        if (wrapper.querySelector('.first-submenu-layer')) return; // return if uk essen mega menu
        const menu = wrapper.querySelector('.navbar-nav');
        const header = document.querySelector('.ume-fixed');
        const headerWidth = header.getBoundingClientRect().width;
        if(menu !== null && menu.classList.contains('ume-main-menu-dropdown-width-restriction')){
            const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

            if(vw > 1199){
                let maxDepth = 0;
                let itemsWithChildren = menu.querySelectorAll('li.menu-item.menu-item-has-children');
                if(Array.from(itemsWithChildren).length > 0){
                    Array.from(itemsWithChildren).forEach(item => {
                        let tempDepth = -1;
                        let tempItem = item;
                        while (tempItem instanceof HTMLElement){
                            tempItem = tempItem.querySelector('.dropdown-menu');
                            tempDepth++;
                        }
                        if(tempDepth > maxDepth){
                            maxDepth = tempDepth;
                        }
                    })
                }
                if(maxDepth > 2){
                    menu.classList.add('ume-main-menu-dropdown-width-restriction-small-screen')
                }
            }

        }
        if(menu !== null){
            const menuWidth = menu.getBoundingClientRect().width;
            if (menuWidth > (headerWidth * 0.5)) {
                let menuItem = menu.querySelectorAll('.menu-item');
                if (menuItem.length > 4) {
                    for (let i = 0; i < 2; i++) {
                        let dropdown = menuItem[i].querySelector('.dropdown-menu-right');
                        if(dropdown !== undefined && dropdown !== null){
                            dropdown.classList.add('dropdown-menu-left');
                            dropdown.classList.add('dropdown-menu-assist');
                            dropdown.classList.remove('dropdown-menu-right');
                            let allSubSub = dropdown.querySelectorAll('.dropdown-menu__side');
                            if (allSubSub.length > 0) {
                                allSubSub.forEach(sub => {
                                    sub.classList.add('dropdown-menu__side-mod')
                                })
                            }
                        }

                    }
                }
            } else {
                if (document.querySelector('.dropdown-menu-assist')) {
                    let allMod = document.querySelectorAll('.dropdown-menu-assist');
                    allMod.forEach(mod => {
                        mod.classList.add('.dropdown-menu-right');
                        mod.classList.remove('.dropdown-menu-assist');
                        mod.classList.remove('.dropdown-menu-left');
                        let allSubSub = mod.querySelectorAll('.dropdown-menu__side-mod');
                        if (allSubSub.length > 0) {
                            allSubSub.forEach(sub => {
                                sub.classList.remove('dropdown-menu__side-mod')
                            })
                        }
                    })
                }
            }
        }


    }


}
export default checkForMenuOverLength;